<i18n src="./resources/locales.json"></i18n>

<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-form ref="sparePartForm" v-model="isValid">
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  class="required-field"
                  v-model="sparePart.name"
                  :label="$t('name')"
                  :rules="[nameRules.required]"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="sparePart.description"
                  :label="`${$t('description')} (${$t('optional')})`"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  class="required-field"
                  v-model="sparePart.tags"
                  :label="$t('tags')"
                  :rules="[tagsRules.required]"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="close">
            {{ $t('cancel') }}
          </v-btn>
          <v-btn color="primary" :disabled="!isValid" @click="save">
            {{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'SparePartDetailModal',

  data() {
    return {
      isValid: false,
      sparePart: {},
      dialog: false,
      defaultSparePart: {
        id: '-1',
        name: '',
        description: '',
        tags: '',
        measures: {},
        unitOfMeasures: []
      }
    };
  },

  computed: {
    formTitle() {
      const { id } = this.sparePart;
      return id === '-1' ? this.$t('newSparePart') : this.$t('editSparePart');
    },

    nameRules() {
      return { required: value => !!value || this.$t('nameIsRequired') };
    },

    tagsRules() {
      return { required: value => !!value || this.$t('tagsAreRequired') };
    }
  },

  methods: {
    ...mapActions('spareParts', ['addSparePart', 'updateSparePart']),

    open(sparePartToUpsert) {
      this.sparePart = Object.assign(
        {},
        sparePartToUpsert || this.defaultSparePart
      );
      this.dialog = true;
    },

    close() {
      this.resetValidations();
      this.isValid = false;
      this.sparePart = Object.assign({}, this.defaultSparePart);
      this.dialog = false;
    },

    async save() {
      const { id } = this.sparePart;
      this.sparePart = Object.assign({}, this.sparePart);

      if (id !== '-1') {
        try {
          await this.updateSparePart(this.sparePart);
          this.$root.$emit(
            'open-status-message-snackbar',
            Object.assign(
              {},
              {
                message: this.$t('sparePartInfoWasUpdatedSuccessfully'),
                messageType: 'success'
              }
            )
          );
        } catch (error) {
          this.$root.$emit(
            'open-status-message-snackbar',
            Object.assign(
              {},
              {
                message: this.$t(
                  'errorWhileUpdatingSparePartInfoPleaseTryAgain'
                ),
                messageType: 'error'
              }
            )
          );
        }
      } else {
        try {
          this.sparePart.measures = JSON.stringify(this.sparePart.measures);
          this.sparePart.unitOfMeasures = JSON.stringify(
            this.sparePart.unitOfMeasures
          );
          await this.addSparePart(this.sparePart);
          this.$root.$emit(
            'open-status-message-snackbar',
            Object.assign(
              {},
              {
                message: `${this.$t('theSparePart')} ${
                  this.sparePart.name
                } ${this.$t('wasCreatedSuccessfully')}`,
                messageType: 'success'
              }
            )
          );
        } catch (error) {
          this.$root.$emit(
            'open-status-message-snackbar',
            Object.assign(
              {},
              {
                message: this.$t('errorWhileCreatingTheSparePart'),
                messageType: 'error'
              }
            )
          );
        }
      }

      this.close();
    },

    resetValidations() {
      this.$refs.sparePartForm.resetValidation();
    }
  }
};
</script>
